// src/features/landing/presentation/components/StrengthSection.jsx
import React from "react";
import "./StrengthSection.css";

export function StrengthSection() {
    return (
        <section className="section strength-section">
            <div className="container">
                {/* Header */}
                <div className="strength-header">
                    <p className="strength-kicker">강점</p>
                    <h2 className="strength-title">
                        <span className="strength-title-red">S</span>TRENGTH
                    </h2>
                </div>

                {/* Main Grid */}
                <div className="strength-grid">
                    {/* Top Left - Platform Text */}
                    <div className="strength-text-block strength-top-left">
                        <p>체계화된 GA전문인력 관리 시스템과</p>
                        <p>경력관리 프로그램*을 통해</p>
                        <p>보험사·GA 채용효율 극대화.</p>
                        <p>기업과 전문인력의 상호가치를</p>
                        <p>실현하는 프리미엄 헤드헌팅 플랫폼 제공</p>
                    </div>

                    {/* Top Right - IT Solution & Know-how */}
                    <div className="strength-circles-block strength-top-right">
                        <div className="circles-container">
                            <div className="circle-item circle-left">
                                <div className="circle-icon">
                                    <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
                                        <path d="M30 10 L30 30 L45 30" stroke="#E31837" strokeWidth="3" fill="none"/>
                                        <rect x="20" y="35" width="10" height="15" fill="#E31837"/>
                                        <path d="M15 25 Q25 20 35 25" stroke="#1a1a1a" strokeWidth="2" fill="none"/>
                                    </svg>
                                </div>
                                <div className="circle-label">IT Solution</div>
                            </div>
                            <div className="circle-item circle-right">
                                <div className="circle-icon">
                                    <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
                                        <circle cx="30" cy="20" r="4" fill="#E31837"/>
                                        <circle cx="20" cy="35" r="4" fill="#E31837"/>
                                        <circle cx="40" cy="35" r="4" fill="#E31837"/>
                                        <circle cx="25" cy="48" r="4" fill="#E31837"/>
                                        <circle cx="35" cy="48" r="4" fill="#E31837"/>
                                        <line x1="30" y1="24" x2="20" y2="31" stroke="#E31837" strokeWidth="2"/>
                                        <line x1="30" y1="24" x2="40" y2="31" stroke="#E31837" strokeWidth="2"/>
                                        <line x1="20" y1="39" x2="25" y2="44" stroke="#E31837" strokeWidth="2"/>
                                        <line x1="40" y1="39" x2="35" y2="44" stroke="#E31837" strokeWidth="2"/>
                                    </svg>
                                </div>
                                <div className="circle-label">Know-how</div>
                            </div>
                        </div>
                        <p className="circles-description">
                            15년 이상 보험업계 전문 노하우와<br/>
                            체계화된 시스템을 바탕으로<br/>
                            GA 전문인력 최적 매칭 서비스 제공
                        </p>
                    </div>

                    {/* Center Circle */}
                    <div className="strength-center-circle">
                        <div className="center-circle-outer">
                            <div className="center-circle-inner">
                                <div className="center-circle-text">
                                    <div className="center-text-en">STRENGTH</div>
                                    <div className="center-text-ko">강점</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Bottom Left - Staff Text */}
                    <div className="strength-text-block strength-bottom-left">
                        <p>보험업계 출신 전문 컨설턴트,</p>
                        <p>마케팅·디자인팀, IT개발팀,</p>
                        <p>운영관리팀 등 전문 조직 구성으로</p>
                        <p>인바운드·아웃바운드 통합 운영</p>
                    </div>

                    {/* Bottom Right - Staff & 구직자 DB */}
                    <div className="strength-circles-block strength-bottom-right">
                        <div className="circles-container">
                            <div className="circle-item circle-left">
                                <div className="circle-icon">
                                    <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
                                        <circle cx="30" cy="22" r="6" stroke="#E31837" strokeWidth="2" fill="none"/>
                                        <path d="M20 38 Q20 30 30 30 Q40 30 40 38" stroke="#E31837" strokeWidth="2" fill="none"/>
                                        <line x1="25" y1="30" x2="20" y2="38" stroke="#E31837" strokeWidth="2"/>
                                        <line x1="35" y1="30" x2="40" y2="38" stroke="#E31837" strokeWidth="2"/>
                                        <circle cx="20" cy="38" r="3" fill="#E31837"/>
                                        <circle cx="40" cy="38" r="3" fill="#E31837"/>
                                        <circle cx="30" cy="30" r="3" fill="#E31837"/>
                                    </svg>
                                </div>
                                <div className="circle-label">Staff</div>
                            </div>
                            <div className="circle-item circle-right">
                                <div className="circle-icon">
                                    <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
                                        <circle cx="30" cy="20" r="4" stroke="#1a1a1a" strokeWidth="2" fill="none"/>
                                        <circle cx="20" cy="28" r="4" stroke="#1a1a1a" strokeWidth="2" fill="none"/>
                                        <circle cx="40" cy="28" r="4" stroke="#1a1a1a" strokeWidth="2" fill="none"/>
                                        <circle cx="25" cy="38" r="4" stroke="#1a1a1a" strokeWidth="2" fill="none"/>
                                        <circle cx="35" cy="38" r="4" stroke="#1a1a1a" strokeWidth="2" fill="none"/>
                                        <path d="M18 48 Q30 42 42 48" stroke="#E31837" strokeWidth="2" fill="none"/>
                                    </svg>
                                </div>
                                <div className="circle-label">GA인재 DB</div>
                            </div>
                        </div>
                        <p className="circles-description">
                            GA매니저·총무·스태프별<br/>
                            정량·정성 평가 완료된<br/>
                            검증된 보험 전문인력 보유
                        </p>
                    </div>
                </div>

                {/* Footer Note */}
                <div className="strength-footer">
                    <p>
                        * 경력관리 프로그램 : GA전문인력의 이력·경력·성향·면접태도·업무역량 등을 정량·정성 평가하여 데이터화하고,
                        각 보험사/GA의 조직문화·상품특성에 최적 매칭된 인재를 추천 및 입사 후 정착까지 관리하는 체계화된 시스템
                    </p>
                </div>
            </div>
        </section>
    );
}
